module.exports = __webpack_public_path__ + "static/media/download-cloud.05a04c13.svg";